/* assets/armonia-product.js
   Scheda prodotto Armonia: <armonia-pdp>
   - galleria (thumb, scroll-snap, contatore, zoom desktop)
   - scelta taglia -> aggiorna prezzo, sconto, Omnibus, Klarna, stato esaurito, URL, sticky, WhatsApp
   - add to cart (drawer Dawn) + sticky bar
   - "Avvisami" per taglia esaurita (Klaviyo Back in stock oppure modulo contatti Shopify)
   - consegna stimata (lun-ven, cutoff, fuso, sabato sì / domenica no): impostazioni in Armonia.config
   Niente dipendenze. Le stringhe arrivano dalla sezione (data-pdp-strings). */
(function () {
  'use strict';
  if (customElements.get('armonia-pdp')) return;

  function fmt(str, map) {
    return String(str).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  function cfg() {
    return (window.Armonia && window.Armonia.config) || {};
  }


  /* Soldi nel formato del negozio (Impostazioni > Mercati / Valuta > Formattazione valuta).
     Stesse regole dei token Shopify, così il prezzo scritto dal server e quello aggiornato dal JS sono identici. */
  function armoniaFormatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    var fmt = format || (cfgMoneyFormat());
    if (!fmt) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat((window.Armonia && window.Armonia.config && window.Armonia.config.locale) || 'it-IT', { style: 'currency', currency: currency }).format(value);
      } catch (e) {
        return value.toFixed(2).replace('.', ',') + ' €';
      }
    }
    function num(decimals, thousands, decimal) {
      var n = value.toFixed(decimals).split('.');
      n[0] = n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return n[1] ? n[0] + decimal + n[1] : n[0];
    }
    return String(fmt).replace(/\{\{\s*(\w+)\s*\}\}/, function (m, t) {
      switch (t) {
        case 'amount': return num(2, ',', '.');
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', ',');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        default: return num(2, ',', '.');
      }
    });
  }
  function cfgMoneyFormat() {
    return (window.Armonia && window.Armonia.config && window.Armonia.config.moneyFormat) || '';
  }

  function money(cents) { return armoniaFormatMoney(cents); }

  function track(name, params) {
    if (window.Armonia && window.Armonia.track) window.Armonia.track(name, params);
  }

  /* ---------- Consegna stimata ---------- */
  function romeNow(tz) {
    var d = new Date();
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
      }).formatToParts(d).forEach(function (p) { parts[p.type] = parseInt(p.value, 10); });
    } catch (e) {
      parts = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours() };
    }
    return {
      date: new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12)),
      hour: (parts.hour || 0) % 24
    };
  }

  function addDays(d, n) {
    var x = new Date(d.getTime());
    x.setUTCDate(x.getUTCDate() + n);
    return x;
  }

  function isBiz(d) {
    var w = d.getUTCDay();
    return w >= 1 && w <= 5;
  }

  function addDeliveryDays(d, n, saturday) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x = addDays(x, 1);
      var w = x.getUTCDay();
      if (w === 0 || (w === 6 && !saturday)) continue;
      n -= 1;
    }
    return x;
  }

  function computeDelivery() {
    var c = cfg();
    var tz = c.timezone || 'Europe/Rome';
    var cutoff = typeof c.cutoffHour === 'number' ? c.cutoffHour : 17;
    var minD = c.deliveryMinDays || 1;
    var maxD = Math.max(c.deliveryMaxDays || 2, minD);
    var sat = c.saturdayDelivery !== false;
    var now = romeNow(tz);
    var shipToday = isBiz(now.date) && now.hour < cutoff;
    var ship = now.date;
    if (!shipToday) {
      ship = addDays(now.date, 1);
      while (!isBiz(ship)) ship = addDays(ship, 1);
    }
    return {
      today: shipToday,
      ship: ship,
      tomorrow: !shipToday && ship.getTime() - now.date.getTime() === 86400000,
      from: addDeliveryDays(ship, minD, sat),
      to: addDeliveryDays(ship, maxD, sat),
      cutoff: cutoff,
      locale: c.locale || 'it-IT'
    };
  }

  function fmtDay(d, locale, opts) {
    var o = opts || { weekday: 'short', day: 'numeric', month: 'short' };
    o.timeZone = 'UTC';
    try {
      return d.toLocaleDateString(locale, o).replace(/\./g, '');
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  /* ---------- Componente ---------- */
  class ArmoniaPdp extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._observers = [];
      this._busy = false;
      this._userNotify = false;

      var sj = this.querySelector('[data-pdp-strings]');
      var vj = this.querySelector('[data-pdp-variants]');
      try { this.S = JSON.parse(sj ? sj.textContent : '{}'); } catch (e) { this.S = {}; }
      try { this.variants = JSON.parse(vj ? vj.textContent : '[]'); } catch (e) { this.variants = []; }

      this.form = this.querySelector('form.armonia-pdp__form');
      this.idInput = this.querySelector('[data-pdp-variant-id]');
      this.atc = this.querySelector('[data-pdp-atc]');
      this.sizeIdx = parseInt(this.dataset.sizeIndex, 10) || 0;
      this.current = this.findVariant() || this.variants[0] || null;

      this.initGallery();
      this.initOptions();
      this.initColors();
      this.initQty();
      this.initCart();
      this.initNotify();
      this.initSticky();
      this.initDelivery();
      if (this.current) this.render(this.current, true);
    }

    disconnectedCallback() {
      this._observers.forEach(function (o) { o.disconnect(); });
      this._observers = [];
    }

    $(sel) { return this.querySelector(sel); }
    $$(sel) { return Array.prototype.slice.call(this.querySelectorAll(sel)); }

    /* ----- Varianti ----- */
    /* Opzioni scelte: { indiceOpzione: valore }. Le opzioni non mostrate (es. colore singolo) non contano. */
    selectedOptions() {
      var groups = this.$$('[data-pdp-option]');
      if (!groups.length) return null;
      var map = {};
      groups.forEach(function (g) {
        var r = g.querySelector('input:checked');
        map[g.getAttribute('data-pdp-option')] = r ? r.value : null;
      });
      return map;
    }

    findVariant() {
      var sel = this.selectedOptions();
      if (!sel) return this.variants[0] || null;
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        var ok = true;
        for (var k in sel) if (v.options[k] !== sel[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    initOptions() {
      var self = this;
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.matches || !t.matches('.armonia-pdp__opt-input')) return;
        var v = self.findVariant();
        self.current = v;
        self.render(v, false);
      });
    }

    /* ----- Colori: al passaggio/focus mostra il nome, al click si apre l'altra scheda ----- */
    initColors() {
      var label = this.$('[data-pdp-color-name]');
      if (!label) return;
      var base = label.getAttribute('data-default') || '';
      function show(txt) {
        label.textContent = txt;
        label.hidden = !txt;
      }
      this.$$('.armonia-pdp__cv').forEach(function (a) {
        var name = a.getAttribute('title') || '';
        a.addEventListener('mouseenter', function () { show(name); });
        a.addEventListener('focus', function () { show(name); });
        a.addEventListener('mouseleave', function () { show(base); });
        a.addEventListener('blur', function () { show(base); });
      });
    }

    /* ----- Render stato ----- */
    render(v, initial) {
      var S = this.S;
      var self = this;
      var sel = this.selectedOptions();

      // etichette opzione selezionata
      this.$$('[data-pdp-option]').forEach(function (g) {
        var r = g.querySelector('input:checked');
        var b = g.querySelector('[data-pdp-option-value]');
        if (r && b) b.textContent = r.value;
      });

      if (!v) {
        if (this.atc) { this.atc.disabled = true; }
        this.setAtcLabel(S.unavailable);
        this.updateNotify(null);
        return;
      }

      if (this.idInput) this.idInput.value = v.id;

      // prezzo
      var onSale = v.compare > v.price;
      var percent = onSale ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
      this.setText('[data-pdp-price]', money(v.price));
      this.setHidden('[data-pdp-compare]', !onSale);
      this.setHidden('[data-pdp-compare-label]', !onSale);
      if (onSale) this.setText('[data-pdp-compare]', money(v.compare));
      this.setHidden('[data-pdp-badge-media]', !onSale);
      this.setHidden('[data-pdp-badge-price]', !onSale);
      this.setHidden('[data-pdp-save]', !onSale);
      if (onSale) {
        this.$$('[data-pdp-badge-text]').forEach(function (n) { n.textContent = fmt(S.badge, { percent: percent }); });
        this.$$('[data-pdp-badge-a11y]').forEach(function (n) { n.textContent = fmt(S.badgeA11y, { percent: percent }); });
        var sv = this.$('[data-pdp-save]');
        if (sv) sv.textContent = fmt(S.save, { amount: money(v.compare - v.price) }) + ' · ';
      }

      // Omnibus: metafield > (opzionale) prezzo barrato. Senza dato la riga resta nascosta.
      var omn = this.$('[data-pdp-omnibus]');
      if (omn) {
        var text = this.dataset.omnibus;
        if (!text && this.dataset.omnibusFallback === 'true' && onSale) text = money(v.compare);
        var showOmn = !!(onSale && text);
        omn.hidden = !showOmn;
        if (showOmn) omn.textContent = fmt(S.omnibus, { price: text });
        var br = this.$('[data-pdp-omnibus-br]');
        if (br) br.hidden = !showOmn;
      }

      // sticky
      this.setText('[data-pdp-sticky-price]', money(v.price));
      var sc = this.$('[data-pdp-sticky-compare]');
      if (sc) { sc.hidden = !onSale; if (onSale) sc.textContent = money(v.compare); }
      var sizeVal = sel && sel[this.sizeIdx] ? sel[this.sizeIdx] : (v.options ? v.options[this.sizeIdx] : null);
      var meta = [this.dataset.brand, this.dataset.color, sizeVal ? fmt(S.stickySize, { size: sizeVal }) : '']
        .filter(Boolean).join(' · ');
      this.setText('[data-pdp-sticky-meta]', meta);

      // Klarna
      this.renderKlarna(v);

      // pulsanti
      var out = !v.available;
      if (this.atc) this.atc.disabled = out;
      this.setAtcLabel(out ? S.soldOut : S.add);
      var sb = this.$('[data-pdp-sticky-atc]');
      if (sb) sb.disabled = false; // in sticky il bottone resta cliccabile: se esaurito porta ad "Avvisami"
      this.setText('[data-pdp-sticky-label]', out ? S.notifyShort || S.soldOut : S.add);
      var express = this.$('[data-pdp-express]');
      if (express) express.hidden = out;

      this.updateNotify(v);
      this.updateWhatsapp(sizeVal);

      // URL e immagine
      if (!initial) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
        if (v.media) this.showMedia(v.media);
        track('select_item_variant', { variant_id: v.id });
      }
    }

    setText(sel, txt) {
      this.$$(sel).forEach(function (n) { n.textContent = txt; });
    }
    setHidden(sel, hidden) {
      this.$$(sel).forEach(function (n) { n.hidden = !!hidden; });
    }
    setAtcLabel(txt) {
      var l = this.$('[data-pdp-atc-label]');
      if (l) l.textContent = txt;
    }

    renderKlarna(v) {
      var box = this.$('[data-pdp-klarna]');
      if (!box || this.dataset.klarna !== 'true') return;
      var min = parseInt(this.dataset.klarnaMin, 10) || 0;
      var max = parseInt(this.dataset.klarnaMax, 10) || 0;
      var ok = v.available && v.price > 0 && (!min || v.price >= min) && (!max || v.price <= max);
      box.hidden = !ok;
      if (!ok) return;
      var t = this.$('[data-pdp-klarna-text]');
      if (t) t.innerHTML = fmt(this.S.klarna, { amount: money(Math.round(v.price / 3)) });
    }

    updateWhatsapp(size) {
      var a = this.$('[data-pdp-wa]');
      if (!a) return;
      var S = this.S;
      var title = this.dataset.productTitle;
      var msg = size ? fmt(S.waMsgSize, { product: title, size: size }) : fmt(S.waMsg, { product: title });
      var num = this.dataset.waNumber;
      if (num) a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
      var note = this.$('[data-pdp-wa-note]');
      if (note) note.textContent = fmt(S.waNote, { message: msg });
    }

    /* ----- Galleria ----- */
    initGallery() {
      var self = this;
      var track = this.$('[data-pg-track]');
      if (!track) return;
      this.track = track;
      this.slides = this.$$('[data-pg-slide]');
      this.thumbs = this.$$('[data-pg-thumb]');
      this.dots = this.$$('[data-pg-dot]');
      this.counter = this.$('[data-pg-counter]');
      this.activeIdx = 0;

      this.thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          self.goTo(parseInt(b.getAttribute('data-pg-thumb'), 10), true);
        });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth || 1;
          self.setActive(Math.round(track.scrollLeft / w));
        });
      }, { passive: true });

      // Zoom desktop (solo puntatore preciso, solo immagini)
      var mq = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)') : null;
      this.slides.forEach(function (s) {
        if (!s.classList.contains('armonia-pg__slide--zoom')) return;
        s.addEventListener('mousemove', function (e) {
          if (!mq || !mq.matches) return;
          var r = s.getBoundingClientRect();
          s.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%');
          s.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%');
          s.classList.add('is-zooming');
        });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zooming'); });
      });
    }

    goTo(i, smooth) {
      if (!this.track || !this.slides[i]) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      this.setActive(i);
    }

    setActive(i) {
      if (i === this.activeIdx || i < 0 || i >= this.slides.length) return;
      this.activeIdx = i;
      this.thumbs.forEach(function (b, n) {
        b.classList.toggle('is-active', n === i);
        if (n === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (this.counter) {
        this.counter.textContent = fmt(this.S.counter, { current: i + 1, total: this.slides.length });
      }
    }

    showMedia(mediaId) {
      if (!this.slides) return;
      for (var i = 0; i < this.slides.length; i++) {
        if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) {
          if (i !== this.activeIdx) this.goTo(i, true);
          return;
        }
      }
    }

    /* ----- Quantità ----- */
    initQty() {
      var input = this.$('[data-pdp-qty-input]');
      if (!input) return;
      function clamp() {
        var n = parseInt(input.value, 10);
        if (!n || n < 1) n = 1;
        if (n > 99) n = 99;
        input.value = n;
      }
      input.addEventListener('change', clamp);
      this.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-pdp-qty]');
        if (!b) return;
        input.value = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-pdp-qty'), 10);
        clamp();
      });
    }

    /* ----- Carrello ----- */
    initCart() {
      var self = this;
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          self.addToCart();
        });
      }
      var sb = this.$('[data-pdp-sticky-atc]');
      if (sb) {
        sb.addEventListener('click', function () {
          if (self.current && !self.current.available) {
            self.openNotify(true);
            return;
          }
          self.addToCart();
        });
      }
    }

    showError(msg) {
      var el = this.$('[data-pdp-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    addToCart() {
      var self = this;
      var v = this.current;
      if (this._busy || !v || !v.available) return;
      var qtyInput = this.$('[data-pdp-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var drawer = document.querySelector('cart-drawer');
      var notif = document.querySelector('cart-notification');
      var sections = [];
      if (drawer) sections.push('cart-drawer');
      if (notif) sections.push('cart-notification-product', 'cart-notification-button');
      sections.push('cart-icon-bubble');

      this._busy = true;
      this.showError('');
      if (this.atc) this.atc.setAttribute('aria-busy', 'true');
      this.setAtcLabel(this.S.adding);

      var config = typeof window.fetchConfig === 'function' ? window.fetchConfig() : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      };
      config.body = JSON.stringify({
        id: v.id,
        quantity: qty,
        sections: sections.join(','),
        sections_url: window.location.pathname
      });

      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url, config)
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status || state.errors) {
            throw new Error(state.description || state.message || 'cart');
          }
          track('add_to_cart', {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
            value: (v.price * qty) / 100,
            items: [{ item_id: String(v.id), item_name: self.dataset.productTitle, item_brand: self.dataset.brand, price: v.price / 100, quantity: qty }]
          });
          document.dispatchEvent(new CustomEvent('armonia:cart-added', { detail: { variant: v.id, quantity: qty } }));
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(state);
          } else if (notif && typeof notif.renderContents === 'function') {
            notif.renderContents(state);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          self.showError(err && err.message && err.message !== 'cart' ? err.message : self.S.error);
        })
        .then(function () {
          self._busy = false;
          if (self.atc) self.atc.removeAttribute('aria-busy');
          self.setAtcLabel(self.current && !self.current.available ? self.S.soldOut : self.S.add);
        });
    }

    /* ----- Avvisami ----- */
    notifyTarget(v) {
      // taglia esaurita da proporre: quella scelta, altrimenti la prima esaurita con le altre opzioni uguali
      var sel = this.selectedOptions();
      var idx = this.sizeIdx;
      if (!v || !sel) return null;
      if (!v.available) return { variant: v, size: v.options[idx] };
      for (var i = 0; i < this.variants.length; i++) {
        var c = this.variants[i];
        if (c.available) continue;
        var same = true;
        for (var j in sel) if (String(j) !== String(idx) && c.options[j] !== sel[j]) { same = false; break; }
        if (same) return { variant: c, size: c.options[idx] };
      }
      return null;
    }

    updateNotify(v) {
      var open = this.$('[data-pdp-notify-open]');
      var panel = this.$('[data-pdp-notify]');
      if (!open || !panel) return;
      var t = this.notifyTarget(v);
      this._target = t;
      if (!t) {
        open.hidden = true;
        panel.hidden = true;
        this._userNotify = false;
        return;
      }
      open.hidden = false;
      open.textContent = fmt(this.S.notifyFor, { size: t.size });
      var title = this.$('[data-pdp-notify-title]');
      if (title) title.textContent = fmt(this.S.notifyTitle, { size: t.size });
      var auto = v && !v.available;
      panel.hidden = !(auto || this._userNotify);
      open.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
    }

    openNotify(focus) {
      var panel = this.$('[data-pdp-notify]');
      if (!panel || !this._target) return;
      this._userNotify = true;
      panel.hidden = false;
      var open = this.$('[data-pdp-notify-open]');
      if (open) open.setAttribute('aria-expanded', 'true');
      if (focus) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var em = this.$('[data-pdp-notify-email]');
        if (em) setTimeout(function () { em.focus({ preventScroll: true }); }, 350);
      }
    }

    initNotify() {
      var self = this;
      var open = this.$('[data-pdp-notify-open]');
      var submit = this.$('[data-pdp-notify-submit]');
      var email = this.$('[data-pdp-notify-email]');
      if (open) {
        open.addEventListener('click', function () {
          var panel = self.$('[data-pdp-notify]');
          if (panel && !panel.hidden && self._userNotify && self.current && self.current.available) {
            self._userNotify = false;
            panel.hidden = true;
            open.setAttribute('aria-expanded', 'false');
          } else {
            self.openNotify(true);
          }
        });
      }
      if (email) {
        email.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); self.submitNotify(); }
        });
      }
      if (submit) submit.addEventListener('click', function () { self.submitNotify(); });

      // link "Avvisami" dalle card: .../prodotto#armonia-notify
      if (window.location.hash === '#armonia-notify') {
        window.setTimeout(function () {
          if (self._target) self.openNotify(true);
        }, 400);
      }
    }

    setNotifyMsg(txt, isError) {
      var m = this.$('[data-pdp-notify-msg]');
      if (!m) return;
      m.textContent = txt || '';
      m.classList.toggle('is-error', !!isError);
    }

    submitNotify() {
      var self = this;
      var email = this.$('[data-pdp-notify-email]');
      var btn = this.$('[data-pdp-notify-submit]');
      var t = this._target;
      if (!email || !t || this._notifyBusy) return;
      if (!email.checkValidity()) {
        email.reportValidity();
        return;
      }
      this._notifyBusy = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      this.setNotifyMsg('');

      var company = this.dataset.klaviyoCompany;
      var req;
      if (company) {
        req = fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + t.variant.id } }
              }
            }
          })
        }).then(function (r) { if (!r.ok) throw new Error('klaviyo'); });
      } else {
        var form = this.querySelector('#armonia-notify-contact');
        if (!form) { this._notifyBusy = false; return; }
        form.querySelector('[data-pdp-contact-email]').value = email.value.trim();
        form.querySelector('[data-pdp-contact-body]').value = fmt(this.S.notifyBody, {
          product: this.dataset.productTitle, size: t.size, variant: t.variant.id
        });
        req = fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) {
            if (!r.ok || r.url.indexOf('contact_posted=true') === -1) throw new Error('contact');
          });
      }

      req.then(function () {
        self.setNotifyMsg(self.S.notifyOk, false);
        email.value = '';
        track('notify_me_submit', { variant_id: t.variant.id, size: t.size });
      }).catch(function () {
        self.setNotifyMsg(self.S.notifyError, true);
      }).then(function () {
        self._notifyBusy = false;
        if (btn) btn.removeAttribute('aria-busy');
      });
    }

    /* ----- Sticky bar ----- */
    initSticky() {
      var bar = this.$('[data-pdp-sticky]');
      var atc = this.atc;
      if (!bar || !atc || !('IntersectionObserver' in window)) return;
      var atcOut = false;
      var footerIn = false;
      function paint() {
        var show = atcOut && !footerIn;
        bar.classList.toggle('is-visible', show);
        if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      }
      bar.setAttribute('inert', '');
      var o1 = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        atcOut = !e.isIntersecting && e.boundingClientRect.top < 0;
        paint();
      });
      o1.observe(atc);
      this._observers.push(o1);
      var footer = document.querySelector('footer');
      if (footer) {
        var o2 = new IntersectionObserver(function (entries) {
          footerIn = entries[entries.length - 1].isIntersecting;
          paint();
        });
        o2.observe(footer);
        this._observers.push(o2);
      }
    }

    /* ----- Consegna ----- */
    initDelivery() {
      var box = this.$('[data-pdp-delivery]');
      if (!box) return;
      var S = this.S;
      var d = computeDelivery();
      var title = this.$('[data-pdp-delivery-title]');
      var note = this.$('[data-pdp-delivery-note]');
      var range = d.from.getTime() === d.to.getTime()
        ? fmtDay(d.from, d.locale)
        : fmtDay(d.from, d.locale) + ' e ' + fmtDay(d.to, d.locale);
      var lead = d.today
        ? fmt(S.deliveryToday, { hour: d.cutoff })
        : fmt(S.deliveryShip, { day: d.tomorrow ? S.deliveryTomorrow : fmtDay(d.ship, d.locale, { weekday: 'long' }) });
      if (title) title.textContent = fmt(S.deliveryTitle, { range: range });
      if (note) note.textContent = lead + ' · ' + S.deliveryFree;
    }
  }

  customElements.define('armonia-pdp', ArmoniaPdp);
})();
